import React, { useEffect, useState } from "react";
import axios from "axios";
import Solicitudes from "./Solicitudes";
import SolicitudesDirector from "./SoliictudesDirector"; // 👈 NUEVO
import Cookies from "universal-cookie";
import { useParams } from "react-router-dom";
import md5 from "md5";
import Swal from "sweetalert2";
import { decryptAES } from "./Crypto";

function Home() {
  const { username } = useParams();
  const cookie = new Cookies();

  const [list, setList] = useState([]);
  const [correo, setCorreo] = useState("");
  const [tipoUsuario, setTipoUsuario] = useState(null); // 👈 NUEVO

  const usernameEncoded = encodeURIComponent(username || "");

  useEffect(() => {
    // 🧱 Validación inicial
    if (!username || username === "undefined" || username.trim() === "") {
      Swal.fire({
        title: "Debe iniciar sesión nuevamente",
        text: "Haz clic en el botón para continuar",
        icon: "warning",
        confirmButtonText: "Continuar",
      }).then(() => {
        window.location.href = "/login";
      });
      return;
    }

    // 👋 Bienvenida (solo una vez)
    const yaMostroAlerta = localStorage.getItem("bienvenida_mostrada");
    if (!yaMostroAlerta) {
      Swal.fire({
        title: "Bienvenido",
        text: "Haz clic en el botón para continuar",
        icon: "success",
        confirmButtonText: "Continuar",
      }).then(() => {
        localStorage.setItem("bienvenida_mostrada", "true");
        window.location.reload();
      });
      return;
    }

    // 🔓 Descifrar correo
    let decryptedEmail = "";
    try {
      decryptedEmail = decryptAES(username);
      console.log("📧 Correo descifrado:", decryptedEmail);
    } catch (err) {
      console.error("❌ Error descifrando el correo:", err);
      Swal.fire({
        title: "Error",
        text: "No se pudo validar su usuario. Inicie sesión nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      }).then(() => {
        window.location.href = "/login";
      });
      return;
    }

    // 📡 Llamado a API
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      validateStatus: (status) => status < 500,
      url: `https://suadesarrollo.azurewebsites.net/api/obtenerIdUsuario?correo=${decryptedEmail}`,
    })
      .then((Response) => {
        console.log("✅ Status:", Response.status);
        console.log("📦 Data:", Response.data);

        if (!Response.data) {
          throw new Error("Respuesta vacía");
        }

        const respuesta = Array.isArray(Response.data)
          ? Response.data[0]
          : Response.data;

        if (!respuesta || !respuesta.id) {
          Swal.fire({
            title: "Usuario no encontrado",
            text: "Debe iniciar sesión nuevamente.",
            icon: "warning",
            confirmButtonText: "Continuar",
          }).then(() => {
            window.location.href = "/login";
          });
          return;
        }

        // ✅ Guardar datos
        setCorreo(decryptedEmail);
        setList(Array.isArray(Response.data) ? Response.data : [Response.data]);

        cookie.set("id", respuesta.id, { path: "/" });
        cookie.set("Nombre", respuesta.nombre, { path: "/" });
        cookie.set(md5("correo"), respuesta.correo_Electronico, { path: "/" });
        cookie.set(md5("contrasena"), respuesta.contrasena, { path: "/" });
        cookie.set("tipo_Usuario", respuesta.tipo_Usuario, { path: "/" });
        cookie.set("institucionid", respuesta.institucionId, { path: "/" });
        cookie.set(md5("Rol"), respuesta.rol, { path: "/" });
        cookie.set("hash", usernameEncoded, { path: "/" });

        // 👇 GUARDAR tipo usuario en estado
        setTipoUsuario(parseInt(respuesta.tipo_Usuario));

        // 🔁 Recarga única
        const yaRecargo = localStorage.getItem("pagina_recargada");
        if (!yaRecargo) {
          localStorage.setItem("pagina_recargada", "true");
          setTimeout(() => window.location.reload(), 800);
        }
      })
      .catch((error) => {
        console.error("🚨 Error:", error);

        if (!error.response) {
          Swal.fire({
            title: "Error de conexión",
            text: "No se pudo conectar con el servidor.",
            icon: "error",
            confirmButtonText: "Intentar de nuevo",
          });
        } else {
          console.log("⚠️ Código:", error.response.status);
          console.log("📩 Detalle:", error.response.data);
        }
      });

    // 👇 fallback por si ya existe cookie
    const tipo = cookie.get("tipo_Usuario");
    if (tipo) {
      setTipoUsuario(parseInt(tipo));
    }
  }, [username]);

  return (
    <React.Fragment>
      {tipoUsuario === 6 || cookie.get("tipo_Usuario") == 6 ? (
        <SolicitudesDirector correoDesencriptado={correo} />
      ) : (
        <Solicitudes correoDesencriptado={correo} />
      )}
    </React.Fragment>
  );
}

export default Home;
